import React, {useState, useRef, useEffect} from 'react'
import ManageBeneficiary from '../../components/Beneficiary/ManageBeneficiary'
import {useSelector} from 'react-redux'
import SubHeader from '../../components/Subheader/Subheader';
import CreateButton from '../../components/Tools/CreateButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';


const BeneficiariesMgt = () => {
    const {authData, financialYears} = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem("globalDateId"));
    const [key, setKey] = useState('list');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchStr, setToSearchStr] = useState('');
    const [title, setTitle] = useState("");
    const location = useLocation();

    useEffect(() => {
        if (location.pathname.includes("agency") || location.search.includes("agency")) {
            setTitle('Agency');
        } else {
            setTitle('Vendor');
        }     
    }, [location])


    const handleDateChange = (start, end, dateColumn, searchStr) => {
        setFromDate(start);
        setToDate(end);
        setToSearchStr(searchStr);
    };

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }

    return (
        <div className='fund_list'>
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-3'>
                <div className="row" style={{ padding: "10px 16px" }}>
                    <div className="col-md-6">
                        <h4 style={{ color: "#28326f", margin:0}}>{title}</h4>
                        <CustomBreadcrumbs linksArray={[]} title={title}/>
                    </div>
                    <div className="col-md-6">
                        <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                            
                        </div>
                    </div>
                </div>
                    <ManageBeneficiary listType={key} fromDate={fromDate} toDate={toDate} searchStr={searchStr}/>
            </div>
            { authData.user.user_type === 'l1' && (
                (location.pathname.includes("agency") || location.search.includes("agency")) ? 
                <CreateButton title={`Add ${title}`} url={"/add-beneficiary?type=agency"}/> : 
                <CreateButton title={`Add ${title}`} url={"/add-beneficiary"}/>
                )
            
            }
        </div>
    )
}

export default BeneficiariesMgt
